import React from 'react'
import { Stack, Typography, styled } from "@mui/material";
import ReactPlayer from 'react-player'



const CustomTypography = styled(Typography) ({
    fontSize: '1.4rem',
    textAlign: 'start',
    lineHeight: '1',
    color: '#ffffff',
    marginTop: '1.5rem',
    marginBottom: '1.5rem',
    '@media (max-width:420px)': {
        fontSize: "20px",
        marginBottom: '20px'
        
      }   
    
    
})


const Video = () => {
  return (    
    
<Stack
      component='section'
      direction="column"
      justifyContent='center'
      maxHeight='70vh'
      width='100vw'
      alignItems='center'
      display='flex'
      overflowY={'hidden'}      
      position='relative'
      overflow='hidden'
      id='video' 
      sx={{
        backgroundColor: '#000000',
        width: '100vw',
        paddingTop: '20px',
        paddingBottom: '20px',
        '@media (max-width:420px)': {
            maxHeight:'70vh'
            
            
          }
      }}    
 >       
<CustomTypography>
<Typography
                variant='h5'
                component= 'h5'
                width='90vw'
                maxWidth='900px'
                sx={{
                    fontWeight: 600,
                    color: '#fff',
                    maxWidth:'85vw',
                    
                }}
                textAlign={'center'}
                >
                    Watch our egress window video!
                </Typography>
                
                    
</CustomTypography>
<ReactPlayer
width='100%'
height='100%'
aspectRatio= '16/9'


style={{
    maxWidth: '1000px', 
    
    '@media (max-width:420px)': {
        width: '300px',
        height: 'auto',
        aspectRatio: '16/9'

        
      }}}

url='https://youtu.be/J7Ob3d4GHG0' />
</Stack>



    );
}

export default Video